export const CHANGE_SIZE = "CHANGE_SIZE";
export const CHANGE_DELAY = "CHANGE_DELAY";
export const SET_DELAY_REF = "SET_DELAY_REF";
export const CHANGE_DIMENSIONS = "CHANGE_DIMENSIONS";
export const SET_VISUALIZATION_ONGOING = "SET_VISUALIZATION_ONGOING";
export const SET_GENERATING = "SET_GENERATING";
export const SET_PATH_VISIBLE = "SET_PATH_VISIBLE";
export const SET_SKIP = "SET_SKIP";
export const SET_RESET = "SET_RESET";
export const CHANGE_MAZE_TYPE = "CHANGE_MAZE_TYPE";
export const CHANGE_SEARCH_TYPE = "CHANGE_SEARCH_TYPE";
